import { Stack } from '@mui/material';
import Form from 'components/Form';
import { IFormValues, IFormRegister, IFormWatch } from 'routes/Main/type';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';
import SectionTitle from '../../components/SectionTitle';

import FirstRadio from './components/FirstRadio';

interface Props extends IFormValues, IFormRegister, IFormWatch {
  disabled?: boolean;
}

const TreatmentPlace = (props: Props) => {
  const { disabled, getValues, setValue, register, watch } = props;

  return (
    <>
      <SectionTitle title="1. 시술장소" />
      <RowContainer xs={12}>
        <RowContent title="" titleRatio={0} childrenRatio={11.8}>
          <FirstRadio
            i18nNullKey="ETC"
            i18nKey="ECMO.TREATMENT.PLACE"
            values={[1, 2, 3, 4, 5, 0]}
            disabled={disabled}
            defaultValue={getValues('treatment_place.place_radio')}
            onChange={v => setValue('treatment_place.place_radio', v)}
            width="auto"
          />
          <Form.MuiTextField
            required={false}
            fullWidth={false}
            disabled={disabled}
            placeholder="직접 입력"
            sx={{ marginLeft: '10px' }}
            {...register('treatment_place.place_input')}
          />
        </RowContent>
      </RowContainer>
    </>
  );
};

export default TreatmentPlace;
